import React, { useState, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "../../helper/axios";
import { AuthContext } from "../../context/AuthContext";
import "./AddProducts.css";
import "./DashboardMain.css";
import FormatPrice from "../../helper/FormatPrice";
import { CartContext } from "../../context/CartContext";

const AddOrder = () => {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");

  const orderStatusList = {
    NewOrder: 1,
    Failed: 2,
    Processing: 3,
    Cancelled: 4,
    Successful: 5,
    Drafted: 6,
    PaymentPending: 7,
  };

  const paymentMethodsList = {
    UPI: 1,
    Card_Payment: 2,
    Cash_Delivery: 3,
    EMI: 4,
    AdminOrder: 5,
  };

  const { addToCart } = useContext(CartContext);

  const location = useLocation();

  const [orders, setOrders] = useState([]);
  const [products, setProducts] = useState([]);
  const [user, setUser] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});

  const [selectedProducts, setSelectedProducts] = useState([]);

  const [productId, setProductId] = useState("");
  const [isinCart, setIsinCart] = useState(false);
  const [orderStatus, setOrderStatus] = useState(null);
  const [paymentMethods, setPaymentMethods] = useState(null);

  const handleStatusChange = (event) => {
    setOrderStatus(event.target.value);
  };

  const handleMethodChange = (event) => {
    setPaymentMethods(event.target.value);
  };

  const handleAddToCart = (product) => {
    addToCart(product, userId);
  };

  // Determine the active class based on the current route
  const getActiveClass = (route) => {
    return location.pathname === route ? "active" : "";
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  // const toggleEdit = () => {
  //   setIsEditing(!isEditing);
  //   // Set the formData to the current user data when entering edit mode
  //   if (isEditing) {
  //     setFormData(user);
  //   }
  // };

  // Function to handle form submission (update user data)
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   try {
  //     // Send a PUT request to update the user data
  //     await axios.put(`/update_user/${userId}`, formData);
  //     // Update the user state with the edited data
  //     setUser(formData);
  //     // Exit edit mode
  //     toggleEdit();
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  const handleProductSelect = (productId) => {
    // Check if the product is already in the selectedProducts array
    if (selectedProducts.includes(productId)) {
      // If it is, remove it from the selectedProducts array
      setSelectedProducts(selectedProducts.filter(id => id !== productId));
    } else {
      // If it's not, add it to the selectedProducts array
      setSelectedProducts([...selectedProducts, productId]);
    }
  };

  const fetchOrders = async () => {
    const allData = { "page": 1 };
    try {
      const response = await axios.get(`/order_read`);
      setOrders(response.data.data);

      const responseProducts = await axios.post(`/product_read`, allData);
      setProducts(responseProducts.data.data);

      const responseUser = await axios.get(`/maitri_search_users?user_id=${userId}`);
      setUser(responseUser.data.data);

    } catch (error) {
      console.error(error.response.data);
      // alert("Failed to fetch products.");
    }
  };

  // Function to handle form input changes
  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData({ ...formData, [name]: value });
  // };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    try {
      const order_insert_data = {
        "order_id": 1001 + Date(),
        "user_id_fk": userId,
        "product_id_fk": selectedProducts[0],
        "is_in_cart": 0,
        "order_status": orderStatus,
        "payment_methods": paymentMethods
      }

      console.log('̥handleFormSubmit-orderStatus', orderStatus);

      const response = await axios.post("/order_insert", order_insert_data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

    } catch (error) {
      // console.error(error.response.data);
      // alert("Add Data First.......");
    }
  };


  return (
    <>
      {/* {isEditing ? (
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="name">Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name || ""}
              onChange={handleInputChange}
            />
          </div>
          <div>
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email || ""}
              onChange={handleInputChange}
            />
          </div> */}
      {/* Add more fields as needed */}
      {/* <button type="submit">Save</button>
        </form>
      ) : (
        <div>
          <p>Name: {user.name}</p>
          <p>Email: {user.email}</p> */}
      {/* Display other user details */}
      {/* <button onClick={toggleEdit}>Edit</button>
        </div>
      )} */}

      <div
        className="modal fade"
        id="addproductModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="addproductModalLabel"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-scrollable modal-xl"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addproductModalLabel">
                <b>Create New Order</b>
              </h5>
              <button
                type="button"
                className="close btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form onSubmit={(e) => handleFormSubmit(e)} className="py-3 m-0 w-100">
                <div className="row">
                  <div className="col-sm-3 mb-4">
                    <label htmlFor="orderStatus" className="form-label">
                      Select Order Status
                    </label> <br />
                    <select id="orderStatus" value={orderStatus} className="form-control" onChange={handleStatusChange}>
                      {Object.keys(orderStatusList).map((status, index) => (
                        <option key={index} value={orderStatusList[status]}>
                          {status}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-sm-3 mb-4">
                    <label htmlFor="producttype" className="form-label">
                      Select Payment Method
                    </label> <br />
                    <select id="producttype" value={paymentMethods} className="form-control" onChange={handleMethodChange}>
                      {Object.keys(paymentMethodsList).map((method, index) => (
                        <option key={index} value={paymentMethodsList[method]}>
                          {method}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-12">
                    <label htmlFor="productlist" className="form-label">
                      Select Products
                    </label>
                    {products.length > 0 ? (
                      <ul
                        id="productlist"
                        value={selectedProducts}
                        className="form-control"
                      // Remove onChange prop for the ul
                      // isMulti // Enable multiple selections
                      >
                        {products.map((product, index) => (
                          <li
                            key={index}
                            value={product.product_id}
                            className="productList-item"
                          >
                            <div className="product-img">
                              <img src={`${product.product_image[0]}`} alt="" />
                            </div>
                            <div className="product-details">
                              <h4>{product.product_name}</h4>
                              <span>{product.product_sku}</span>
                              <span> | {product.category_name}</span>
                            </div>
                            <div className="product-price">
                              <span><FormatPrice price={product.product_price} /></span>
                            </div>
                            <div className="product-btn text-end">
                              {/* Add a button to add the product to the cart */}
                              {/* <button onClick={() => handleAddToCart(product)} className="btn btn__primary">Add to Cart</button> */}
                              <input
                                type="checkbox"
                                value={product.product_id}
                                checked={selectedProducts.includes(product.product_id)}
                                onChange={() => handleProductSelect(product.product_id)}
                                className="form-check-input"
                              />
                            </div>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p>Loading products...</p>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-12">
                    <div className="text-end">
                      <button type="submit" className="btn btn__primary mt-3">
                        Create
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div >
      </div >
    </>
  );
};
export default AddOrder;
